(function (factory) {
    var undef = 'undefined';
    var root = typeof window !== undef ? window : typeof global !== undef ? global : this;
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(function () {
            return factory(root);
        });
    } else if (typeof module === 'object' && module.exports) {
        // CommonJS
        module.exports = factory(root);
    } else{
        root.MessageServiceSwitchBoard=factory(root);
    }
})(function(globalChannel){
    var doc = document;
    if(globalChannel.MessageChannel){
        var Switchboard=MessageChannel;
    } else {
        var switchboardType="div";
        function Switchboard(){
            this.port1=doc.createElement(switchboardType);
        }
        Switchboard.prototype = {
            port1 : null,
            port2 : null
        };
    }
    return Switchboard;
});